const { REACT_APP_API_URI } = process.env

// Calls made for the same guid within this window share one request. On login,
// both `Auth` and the `Accueil` page ask for the statuses back to back.
const DEDUPE_WINDOW_MS = 5000

let lastCall = { guid: null, at: 0, promise: null }

// Fetches the live account statuses (password changed, eduID linked, MFA)
// for a student. Resolves to `null` when the API does not answer 200.
export const fetchAccountsStatuses = (guid) => {
    const now = Date.now()
    if (
        lastCall.promise &&
        lastCall.guid === guid &&
        now - lastCall.at < DEDUPE_WINDOW_MS
    ) {
        return lastCall.promise
    }

    const promise = fetch(`${REACT_APP_API_URI}/accounts-statuses`, {
        method: 'POST',
        body: JSON.stringify({ guid }),
        headers: { 'Content-Type': 'application/json' },
    }).then((res) => (res.status === 200 ? res.json() : null))

    lastCall = { guid, at: now, promise }
    return promise
}
